import React from "react";
import styles from "./index.module.scss";

export default function Articles(props) {
  const { children, isTransparent = false } = props;
  return (
    <section
      className={`${styles.container} ${isTransparent && styles.transparent}`}
    >
      {children}
    </section>
  );
}
